import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { DURATION_PARAM_INIT_LOADING, DURATION_PARAM_INIT_SUCCESS, DURATION_PARAM_INIT_FAIL } from '@/store/types'

export const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {}

const mutations = {
  [DURATION_PARAM_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [DURATION_PARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [DURATION_PARAM_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async durationParamManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.durationParamManagement
    commit(DURATION_PARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(DURATION_PARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(DURATION_PARAM_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
